import { TEST_IDS } from '@va/constants';
import { onContactSupport } from '@va/dashboard/util-helpers/misc';
import { useTranslate } from '@va/localization';
import { fontWeights, Paragraph } from '@va/ui/design-system';
import { DashboardAppWorker } from '@va/util/misc';

export function SupportText({ activeStepKey }: { activeStepKey: string }) {
  const translate = useTranslate();
  return (
    <Paragraph
      className='text-center my-3 cursor-pointer underline'
      colorClassName='text-primary'
      weight={fontWeights.medium}
      data-testid={TEST_IDS.helpers.createFeatureOnboardingElementId('support-text')}
      onClick={() => {
        onContactSupport();
        DashboardAppWorker.trackEvent({
          category: 'Onboarding',
          action: 'onclick',
          label: 'Need help onboarding?',
          value: `onboarding-step-${activeStepKey}`,
        });
      }}
      onMouseOver={() => {
        DashboardAppWorker.trackEvent({
          category: 'Onboarding',
          action: 'onmouseover',
          label: 'Need help onboarding?',
          value: `onboarding-step-${activeStepKey}`,
        });
      }}
    >
      {translate('all.onboarding.supportText')}
    </Paragraph>
  );
}
